import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppYubleCodePopupPage } from './app-yuble-code-popup';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    AppYubleCodePopupPage,
  ],
  imports: [
    IonicPageModule.forChild(AppYubleCodePopupPage),
    PipesModule,
  ],
})
export class AppYubleCodePopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-yuble-code-popup/app-yuble-code-popup.module.ts